import styled from "styled-components";
import { unit } from "../../../theme/metrics";
import { typeBodyMd, typeHeadingSm, typeLabelMd } from "../../../theme/typography";

export const StyledContainer = styled.div`
	display: flex;
  flex-direction: column;
  row-gap: ${unit(2)};
`

export const StyledLabel = styled.div`
	${typeLabelMd};
	color: ${props => props.theme.alternative};
`;

export const StyledHeading = styled.h3`
	${typeHeadingSm};
  color: ${props => props.theme.primary};
`;

export const StyledDescription = styled.p`
  ${typeBodyMd}
	color: ${props => props.theme.alternative};

	// display: -webkit-box;
  // -webkit-line-clamp: 7;
  // -webkit-box-orient: vertical;  
  // overflow: hidden;

	p{
		margin-bottom: ${unit(2)};

		&:last-child{
			margin-bottom: 0;
		}
	}

	a {
		color: ${props => props.theme.alternative};
	}
`;